import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  LinearProgress,
  Typography,
} from '@mui/material';
import Button from '@mui/material/Button';
import React from 'react';
import { useTranslation } from 'react-i18next';

export interface ImportLibraryDialogProps {
  open: boolean;
  readCount?: number;
  importedCount?: number;
  allFilesCount?: number;
  importing?: boolean;
  failedFiles?: string[];
  onClose?: (ev: React.MouseEvent) => void;
  onCancel?: (ev: React.MouseEvent) => void;
}

export const ImportLibraryDialog: React.FC<ImportLibraryDialogProps> = (props) => {
  const { t } = useTranslation();
  const progress =
    props.allFilesCount && props.readCount ? (props.readCount / props.allFilesCount) * 100 : 0;

  const handleCancelDialog = (ev: React.MouseEvent) => {
    props.onCancel?.(ev);
  };

  const handleCloseDialog = (ev: React.MouseEvent) => {
    props.onClose?.(ev);
  };

  return (
    <Dialog open={props.open} maxWidth="sm" fullWidth>
      <DialogTitle variant="h3">{t('importingYourLibrary', 'Importing your library')}</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <Box sx={{ width: '100%', mr: 1 }}>
            <LinearProgress variant="determinate" value={progress} />
          </Box>
          <Box>
            <Typography color="primary">{`${Math.round(progress)}%`}</Typography>
          </Box>
        </Box>
        <Box sx={{ minHeight: '4lh' }}>
          <Typography color="secondary">
            {t('readCountAllFilesCountFilesRead', '{{readCount}}/{{allFilesCount}} files read', {
              readCount: props.readCount,
              allFilesCount: props.allFilesCount,
            })}
          </Typography>
          {!props.importing && (
            <Typography color="textDisabled">
              {t('importedCountNewTracksAdded', '{{importedCount}} new tracks added', {
                importedCount: props.importedCount,
              })}
            </Typography>
          )}
          {!props.importing && (
            <Typography color="textDisabled">
              {props.failedFiles?.length || 0} {t('filesFailed', 'files failed')}
            </Typography>
          )}
          {!props.importing && (
            <Typography color="success">{t('importDone', 'Import done!')}</Typography>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        {props.importing && (
          <Button variant="contained" color="error" onClick={handleCancelDialog}>
            {t('cancel', 'Cancel')}
          </Button>
        )}
        {!props.importing && (
          <Button variant="contained" color="primary" onClick={handleCloseDialog}>
            {t('close', 'Close')}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};
